import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export const StatusDot = ({ ok, busy }) => {
  if (busy) return <Loader2 className="h-3.5 w-3.5 text-zinc-400 animate-spin" />;
  if (ok) return <CheckCircle2 className="h-3.5 w-3.5 text-[#22C55E]" />;
  return <XCircle className="h-3.5 w-3.5 text-[#EF4444]" />;
};

export const StatusRow = ({ row, onAction, busy }) => {
  return (
    <div className="flex items-center gap-2 py-1.5 border-b border-zinc-900/60 last:border-b-0" data-testid={`status-row-${row.key}`}>
      <StatusDot ok={row.ok} />
      <div className="flex-1 min-w-0">
        <div className="text-[11px] text-zinc-200 font-medium truncate">{row.name}</div>
        <div className="text-[9px] uppercase tracking-widest text-zinc-500 font-mono truncate">{row.detail}</div>
      </div>
      {row.actionable && (
        <button
          onClick={() => onAction(row)}
          disabled={busy}
          className="text-[9px] uppercase tracking-widest px-2 py-1 border border-zinc-800 hover:border-[#007AFF]/60 text-[#007AFF] hover:text-white font-mono disabled:opacity-50"
          data-testid={`status-action-${row.key}`}
        >
          {row.action_label}
        </button>
      )}
    </div>
  );
};
